module.exports = __webpack_public_path__ + "static/media/spid-ico-circle-lb~LegQefra.27197b71.svg";